export default {
  AIRFLOW_URL: 'https://demo-af.optimization.choreograph.com',
  ENV: 'demo',
};
